import axios from 'axios';
import { multipleConfig } from 'src/app/services/control-panel/control-panel.service';
import { finalUrlsConfig } from 'src/configs/url.config';

declare module 'axios' {
  export interface AxiosRequestConfig {
    blockSpinner?: boolean;
    blockErrorHandler?: boolean;
    flag?: boolean;
  }
}

const setToken = (newToken?: string) => {
  axiosInstance.defaults.headers.common.Authorization = newToken ? `Bearer ${newToken}` : undefined;
  surferAxios.defaults.headers.common.Authorization = newToken ? `Bearer ${newToken}` : undefined;
  dfmAxios.defaults.headers.common.Authorization = newToken ? `Bearer ${newToken}` : undefined;
};

const setSystemLoginToken = (newToken?: string) => {
  systemLoginAxios.defaults.headers.common.Authorization = newToken ? `Bearer ${newToken}` : undefined;
};

const axiosInstance = axios.create({
  baseURL: finalUrlsConfig().webServerBaseURL,
});

const surferAxios = axios.create({
  baseURL: finalUrlsConfig().surferURL,
});
const dfmAxios = axios.create({
  baseURL: finalUrlsConfig().dfmURL,
});
const messengerAxios = axios.create({
  baseURL: finalUrlsConfig().cppMessengerURL,
});
const systemLoginAxios = axios.create({
  baseURL: finalUrlsConfig().systemLoginWebServerBaseURL,
});
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     // whatever you want to do with the error
//     message.error(error?.response?.data?.message);
//   },
// );
// surferAxios.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     // whatever you want to do with the error
//     message.error('Axios Erroru');
//     throw error;
//   },
// );
// dfmAxios.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     // whatever you want to do with the error
//     message.error('Axios Erroru');
//     throw error;
//   },
// );

// LOAD-BALANCER MULTIPLE CONFIG INTERCEPTOR
// const dfmInterceptor =
dfmAxios.interceptors.request.use(async (config) => {
  try {
    if (config.url === finalUrlsConfig().controlPanel.multipleConfig) {
      return config;
    }

    const { data }: any = await multipleConfig({ moduleName: 'nginrDFM', portType: 2 });
    config.baseURL = `https://${data.moduleHost}/dfm`;

    return config;
  } catch (error) {
    console.log('Pre request interceptor error:', error);
    return config;
  }
});

// close dfm interceptor
// axiosInstance.interceptors.request.eject(dfmInterceptor);

export { axiosInstance, dfmAxios, messengerAxios, setSystemLoginToken, setToken, surferAxios, systemLoginAxios };
